import { frontendURL } from '../../../../helper/URLHelper';

export default {
  routes: [
    {
      path: frontendURL('accounts/:accountId/profile'),
      name: 'profile_settings',
      roles: ['administrator', 'agent'],
      component: () => import('../Wrapper'),
      props: {
        headerTitle: 'PROFILE_SETTINGS.TITLE',
        icon: 'edit',
        showNewButton: false,
        showSidemenuIcon: false,
      },
      children: [
        {
          path: 'settings',
          name: 'profile_settings_index',
          component: () => import('./Index.vue'),
          roles: ['administrator', 'agent'],
        },
      ],
    },
  ],
};
